import { css } from 'styled-components'

export default css`
  .BaseModal-Content.popup {
    // Change width here. Use "interactive" if using a different variant
    // All changes here will affect the modal as a whole
    width: 750px;
  }

  &.ConnectPhysicalCardModal .BaseModal-Body {
    // Override any Modal styling here! This will be your main target CSS selector
  }
`
